module.exports = __webpack_public_path__ + "static/img/main2.f8da5b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/programme/main2.png
// module id = tbSa
// module chunks = 1